import { Provider } from 'react-redux';
import App from './widget';
import './global.scss';
import { store } from '../store';

ReactDOM.render(
  <Provider store={store}>
    <App />
  </Provider>,
  document.getElementById('root')
);

if (module.hot) {
  module.hot.accept();
}



// WEBPACK FOOTER //
// ./src/widget/widget.app.js